var exports = {
  "k": "x9245d464--0ea11b--container",
};

module.exports = exports;
